export const TERM_SESSION = 'Session';
export const TERM_TURN = 'Turn';
export const TERM_CONCURRENT = 'Active Sequences (p95)';
export const TERM_TOKENS_PER_TURN = 'Tokens per turn';
